import React from "react";
import Slider from "react-slick";
import ServiceCard from "./serviceCard";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const services = [
  {
    title: "Supported Living",
    image: "https://res.cloudinary.com/dsnontai6/image/upload/v1685474566/pexels-vlada-karpovich-5790702_fywt9a.jpg",
  },
  {
    title: "Mental Health Home Care",
    image: "https://res.cloudinary.com/dsnontai6/image/upload/v1685474565/pexels-matthias-zomer-339620_lrp3xr.jpg",
  },
  { 
    title: "Respite Care",
    image: "https://res.cloudinary.com/dsnontai6/image/upload/v1685474569/pexels-kampus-production-7551684_xa7sm2.jpg",
  },
  {
    title: "Dementia Care",
    image: "https://res.cloudinary.com/dsnontai6/image/upload/v1685474569/pexels-rdne-stock-project-6646990_kyx1sk.jpg",
  },
  {
    title: "Learning Support",
    image: "https://images.pexels.com/photos/8035972/pexels-photo-8035972.jpeg",
  },
  {
    title: "Personal Care",
    image: "https://images.pexels.com/photos/7345465/pexels-photo-7345465.jpeg",
  },
];

const Carousel = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,             // ✅ enable autoplay
    autoplaySpeed: 2500,        // ✅ slide interval (3 seconds)
    pauseOnHover: true, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ],
  };

  var settings2 = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,             // ✅ enable autoplay
    autoplaySpeed: 2500,        // ✅ slide interval (3 seconds)
    pauseOnHover: true, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ],
  };

  return (
    <>
    <div className="carousel">
      <Slider {...settings}>
        {services.map((service, i) => (
          <ServiceCard key={i} title={service.title} image={service.image} />
        ))}
      </Slider>
    </div>
    <div className="carousel2">
      <Slider {...settings2}>
        {services.map((service, i) => (
          <ServiceCard key={i} title={service.title} image={service.image} />
        ))}
      </Slider>
    </div>
    </>
  );
};

export default Carousel;
